import { render, staticRenderFns } from "./AppointmentsChanging.vue?vue&type=template&id=449a220b"
import script from "./AppointmentsChanging.vue?vue&type=script&lang=js"
export * from "./AppointmentsChanging.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsChanging.vue?vue&type=style&index=0&id=449a220b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports